import { useEffect, useState } from 'react'

const TutorialOverlay = () => {
    const [visible, setVisible] = useState(false)
    const [closed, setClosed] = useState(false)

    useEffect(() => {
        // Efeito de fade in
        const fadeInTimer = setTimeout(() => setVisible(true), 500)

        // Auto-close após 10 segundos
        const autoCloseTimer = setTimeout(() => {
            setVisible(false)
            setTimeout(() => setClosed(true), 1000)
        }, 10000)

        return () => {
            clearTimeout(fadeInTimer)
            clearTimeout(autoCloseTimer)
        }
    }, [])

    const handleClose = () => {
        setVisible(false)
        setTimeout(() => setClosed(true), 1000) // Aguardar animação
    }

    if (closed) return null

    return (
        <>
            <style>{`
                @keyframes floating {
                    0%, 100% {
                        transform: translateY(0px);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                }
                .floating {
                    animation: floating 3s ease-in-out infinite;
                }
                .floating-arrow {
                    animation: floating 2s ease-in-out infinite;
                }
            `}</style>
            <div
                className={`absolute z-[10002] transition-opacity duration-1000 ease-in-out ${visible ? 'opacity-100' : 'opacity-0'} w-[120px] md:w-[160px] left-[calc(50%-60px)] md:left-[calc(50%-80px)]`}
                style={{
                    bottom: '90px',
                    pointerEvents: visible ? 'auto' : 'none',
                    animation: 'floating 3s ease-in-out infinite'
                }}
            >
                <div className="relative bg-[#0A1E3A]/80 p-1.5 rounded-lg shadow-xl border border-blue-800/30 backdrop-blur-md">
                    {/* Botão de Fechar */}
                    <button
                        onClick={handleClose}
                        className="absolute top-0.5 right-0.5 text-blue-300 hover:text-white transition-colors"
                        aria-label="Fechar tutorial"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>

                    <h3 className="text-white font-bold text-[8px] md:text-[10px] mb-1 pr-2">Configuração de Automação</h3>

                    <p className="text-blue-100 text-[6px] md:text-[8px] leading-tight mb-1">
                        É aqui que configuraremos a automatização de seus serviços através do poder da inteligência artificial melhorando a experiência de seus clientes.
                    </p>

                    <p className="text-blue-100 text-[6px] md:text-[8px] leading-tight mb-1">
                        Nessa função demonstrativa do AscFlow, mostraremos um exemplo de como otimizaremos seu negócio de maneira inovadora.
                    </p>

                    <div className="flex items-center gap-0.5 text-[6px] md:text-[7px] text-blue-300 font-semibold bg-blue-900/30 p-1 rounded-md border border-blue-800/30">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="10"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="floating-arrow"
                        >
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <polyline points="19 12 12 19 5 12"></polyline>
                        </svg>
                        <span>Clique em "EXECUTAR" para iniciar</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TutorialOverlay
